// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"e5-z","colorTextValue":"f5-z","swatches":"g5-z","collapseLink":"h5-z","isCollapsed":"i5-z","dropdown":"j5-z","disabled":"k5-z"};